import { render } from "./RecursiveFolderContainer.vue?vue&type=template&id=04e8e5aa&scoped=true"
import script from "./RecursiveFolderContainer.vue?vue&type=script&lang=js"
export * from "./RecursiveFolderContainer.vue?vue&type=script&lang=js"

import "./RecursiveFolderContainer.vue?vue&type=style&index=0&id=04e8e5aa&lang=scss"
import "./RecursiveFolderContainer.vue?vue&type=style&index=1&id=04e8e5aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e8e5aa"]])

export default __exports__